import { createSlice } from '@reduxjs/toolkit';
import { DefaultCompany, DefaultRole } from '@src/types/common';
import { getCompaniesPreview, getUserDetail } from './userSidebarThunk';

interface Companies extends DefaultCompany {
  company: {
    name: string;
  };
}

interface InitialState {
  id: number;
  isOpen: boolean;
  userInfo: {
    role: DefaultRole;
    name: string;
    email: string;
    mobileNumber: string;
    companies?: Companies[];
  };
}

const initialState: InitialState = {
  id: 0,
  isOpen: false,
  userInfo: {
    role: 'user',
    email: '',
    name: '',
    mobileNumber: '',
    companies: [],
  },
};

const userSidebarSlice = createSlice({
  name: 'users/userSidebar',
  initialState,
  reducers: {
    openSidebar(state, { payload }) {
      state.isOpen = !state.isOpen;
      state.id = payload;
    },
    onChangeSelectedRole(state, { payload }) {
      state.userInfo.role = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUserDetail.fulfilled, (state, { payload }) => {
      const { id, name, email, mobileNumber, role } = payload;
      const userInfo = {
        role,
        id,
        name,
        email,
        mobileNumber,
      };

      state.id = payload.id;
      state.userInfo = { ...userInfo };
    });
    builder.addCase(getCompaniesPreview.fulfilled, (state, { payload }) => {
      state.userInfo.companies = [...payload];
    });
  },
});

export const { openSidebar, onChangeSelectedRole } = userSidebarSlice.actions;

export default userSidebarSlice.reducer;
